import React from "react";

const Footer = () => {
  return (
    <footer class="bg-black px-12 md:px-0  relative z-10 bottom-0">
      <div className="container w-5/6 mx-auto md:px-24">
        <div class="hidden md:block md:pt-16 md:mx-auto md:w-1/2 lg:hidden ">
          <img
            src="https://onetrusthomeloans.com/wp-content/uploads/2021/12/OTHL-logo.png"
            alt="OneTrust Home Loans "
          />
        </div>
        <div class="flex flex-col py-24 md:flex-row">
          <div class="mb-16 self-center max-w-xl w-4/5 md:hidden lg:block lg:self-none lg:mb-0 lg:pr-20 lg:w-1/4">
            <img
              src="https://onetrusthomeloans.com/wp-content/uploads/2021/12/OTHL-logo.png"
              alt="OneTrust Home Loans"
            />
          </div>
          <div class="mb-10 md:w-1/3 md:mb-0 md:px-10 lg:w-1/4">
            <div class="menu-footer-first-menu-container">
              <ul id="menu-footer-first-menu" class="nav list-none">
                <li
                  id="menu-item-204"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/about-us/"
                  >
                    About Us
                  </a>
                </li>
                <li
                  id="menu-item-2767"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/home-loan-options/"
                  >
                    Loan Programs
                  </a>
                </li>
                <li
                  id="menu-item-1000"
                  class=" menu-item menu-item-type-custom menu-item-object-custom"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/Careers/"
                  >
                    Careers
                  </a>
                </li>
                <li
                  id="menu-item-1001"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/contact-us/"
                  >
                    Contact Us
                  </a>
                </li>
                <li
                  id="menu-item-2769"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/mortgage-calculators/"
                  >
                    Mortgage Calculators
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-10 md:w-1/3 md:mb-0 md:px-10 lg:w-1/4">
            <div class="menu-footer-second-menu-container">
              <ul id="menu-footer-second-menu" class="nav list-none">
                <li
                  id="menu-item-1001"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/case-transfer-request/"
                  >
                    Case Transfer Request
                  </a>
                </li>
                <li
                  id="menu-item-1271"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/terms-of-use/"
                  >
                    Terms of Use
                  </a>
                </li>
                <li
                  id="menu-item-2769"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="https://transparency-in-coverage.uhc.com/"
                  >
                    Transparency in Coverage
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:w-1/3 md:px-10 lg:w-1/4">
            <div class="menu-footer-third-menu-container">
              <ul id="menu-footer-third-menu" class="nav list-none">
                <li
                  id="menu-item-174"
                  class=" menu-item menu-item-type-custom menu-item-object-custom"
                >
                  <a
                    target="_blank"
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="https://secure2.cpteller.com/portal/?op=RxAluX10MCkX"
                  >
                    Make a Mortgage Payment
                  </a>
                </li>
                <li
                  id="menu-item-2768"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/schedule-consultation/"
                  >
                    Schedule a Consultation
                  </a>
                </li>
                <li
                  id="menu-item-5374"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/cookie-information-opt-out/"
                  >
                    Cookie Information & Opt-Out
                  </a>
                </li>
                <li
                  id="menu-item-5374"
                  class=" menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="text-16 text-white font-light border-b border-transparent hover:border-white sm:text-18"
                    href="/what-you-need-to-know-about-eclosing-and-esigning/"
                  >
                    Learn about eClosing
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row md:flex-wrap pb-24">
          <div class="md:w-2/5 lg:w-1/3 xl:w-1/4">
            <div class="flex flex-row">
              <img
                class="w-20 h-20"
                src="https://onetrusthomeloans.com/wp-content/themes/altum/dist/images/icons/Equal_Housing_Lender_White_7d1a033e.png"
                alt="Equal Housing Lender"
              />
              <div class="mt-3 ml-10">
                <a
                  class="text-white text-15 underline hover:text-green-primary"
                  href="/privacy-policy"
                >
                  Privacy
                </a>
                <span class="text-15 text-white inline-block mx-4">|</span>
                <a
                  class="text-white text-15 underline hover:text-green-primary"
                  href="/licensing-information"
                >
                  Licensing
                </a>
                <br />
                <a
                  class="text-white text-15 underline hover:text-green-primary"
                  href="https://www.nmlsconsumeraccess.org/"
                  target="_blank"
                >
                  NMLS Consumer Access
                </a>
              </div>
            </div>
            <p class="text-white text-17 mt-10">© 2023 OneTrust Home Loans</p>
          </div>
          <div class="flex flex-col items-center justify-center border border-black mt-16 md:w-3/5 md:mt-0 md:px-10 lg:w-1/3 lg:px-0 xl:px-10 xl:w-1/2">
            <p class="text-15 text-white">
              Loans Provided by OneTrust Home Loans, a dba of CalCon Mutual
              Mortgage LLC NMLS #46375 (www.nmlsconsumeraccess.org); 3838 Camino
              del Rio N Suite 305, San Diego, CA 92108. Corporate phone (888)
              447-0389.
            </p>
            <p class="text-15 text-white mt-1">
              All products are not available in all states. All options are not
              available on all programs. All programs are subject to borrower
              and property qualifications. Rates, terms and conditions are
              subject to change without notice.
            </p>
            <p class="text-15 text-white mt-1">
              By refinancing your existing loan, your total finance charges may
              be higher over the life of the loan. (Reference: 10 VAC 5-160-60
              (F))
            </p>
          </div>
          <div class="footer-social-media flex flex-row items-start justify-center mt-16 lg:w-1/3 xl:w-1/4 xl:mt-0">
            {/* <a
              href="https://www.facebook.com/pg/OneTrustHomeLoans/posts"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Vist Our Facebook"
            > */}
            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="58.78"
                height="58.78"
                viewBox="0 0 58.78 58.78"
              >
                <title>facebook-icon</title>
                <path
                  d="M57.62,29.39A28.24,28.24,0,1,1,29.39,1.15,28.23,28.23,0,0,1,57.62,29.39Z"
                  style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width: 2.305000066757202px"
                ></path>
                <path
                  d="M25.7,48c0-.09,0-.18,0-.26V32H20.53c-.23,0-.23,0-.23-.22V26c0-.18.05-.22.22-.22h5.19v-.19c0-1.61,0-3.22,0-4.83A8.76,8.76,0,0,1,26.56,17a6.75,6.75,0,0,1,3.61-3.42,8.39,8.39,0,0,1,3.42-.65c1.36,0,2.71.08,4.06.13l.75.06c.14,0,.19.06.19.2v2.41c0,1,0,1.9,0,2.84,0,.17,0,.22-.21.22-1,0-2.06,0-3.08,0a7.33,7.33,0,0,0-1.4.16,1.94,1.94,0,0,0-1.57,1.65,5.47,5.47,0,0,0-.11,1.07c0,1.31,0,2.63,0,3.94,0,0,0,.08,0,.14h5.9c.25,0,.26,0,.22.24-.13,1-.27,2.06-.4,3.1-.11.86-.22,1.72-.32,2.59,0,.33,0,.33-.37.33h-5V48Z"
                  style="fill: #fff"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/onetrust-home-loans"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Our LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="58.79"
                height="58.78"
                viewBox="0 0 58.79 58.78"
              >
                <title>linkedin-icon</title>
                <path
                  d="M57.62,29.39A28.24,28.24,0,1,1,29.38,1.15h0A28.23,28.23,0,0,1,57.62,29.38Z"
                  transform="translate(0.01 0)"
                  style="fill: none;stroke: #fff;stroke-miterlimit: 10;stroke-width: 2.305000066757202px"
                ></path>
                <path
                  d="M15.63,24.83h6.45V44.14H15.63Zm23.26,9.39c0-3.22-1.29-4.76-3.29-4.76-1.77,0-3.51,1.27-3.51,4.1V44.14H25.64V24.83h6.45v2.45a6.48,6.48,0,0,1,5.77-3c6.19,0,7.48,4.74,7.48,8.91v10.9H38.89Zm-20-18.85a3.53,3.53,0,0,1,3.64,3.41,3.53,3.53,0,0,1-3.64,3.42h0a3.52,3.52,0,0,1-3.63-3.42,3.52,3.52,0,0,1,3.63-3.41h0"
                  transform="translate(0.01 0)"
                  style="fill: #fff"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/onetrusthomeloans/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Our Instagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="58.79"
                height="58.78"
                viewBox="0 0 58.79 58.78"
              >
                <title>instagram-icon</title>
                <path
                  d="M57.62,29.39A28.24,28.24,0,1,1,29.38,1.15h0A28.23,28.23,0,0,1,57.62,29.38Z"
                  transform="translate(0.01 0)"
                  style="fill: none;stroke: #fff;stroke-miterlimit: 10;stroke-width: 2.305000066757202px"
                ></path>
                <path
                  d="M36.32,12.35H22.46A9.69,9.69,0,0,0,12.81,22V36.77a9.69,9.69,0,0,0,9.65,9.66H36.32A9.69,9.69,0,0,0,46,36.77V22A9.69,9.69,0,0,0,36.32,12.35Zm7.1,24.42a7.14,7.14,0,0,1-7.1,7.1H22.46a7.14,7.14,0,0,1-7.1-7.1V22a7.14,7.14,0,0,1,7.1-7.1H36.32a7.14,7.14,0,0,1,7.1,7.1Zm-14-16.64a9.13,9.13,0,1,0,9.13,9.13A9.13,9.13,0,0,0,29.44,20.13Zm0,15.12a6,6,0,1,1,6-6A6,6,0,0,1,29.4,35.25ZM40.87,20a2.16,2.16,0,1,1-4.32,0,2.16,2.16,0,1,1,4.32,0Z"
                  transform="translate(0.01 0)"
                  style="fill: #fff"
                ></path>
              </svg>
            </a> */}
            {/* <a
              href="https://twitter.com/OneTrustHL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Our Twitter"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="58.79"
                height="58.78"
                viewBox="0 0 58.79 58.78"
              >
                <title>twitter-icon</title>
                <path
                  d="M57.62,29.39A28.24,28.24,0,1,1,29.38,1.15h0A28.23,28.23,0,0,1,57.62,29.38Z"
                  transform="translate(0.01 0)"
                  style="fill: none;stroke: #fff;stroke-miterlimit: 10;stroke-width: 2.305000066757202px"
                ></path>
                <path
                  d="M46.78,18.59a10.87,10.87,0,0,1-2.68,2.93,1.84,1.84,0,0,0-.74,1.62C43.08,30.87,39.89,37.07,33.19,41s-13.76,3.71-20.64,0l-.55-.4A19.83,19.83,0,0,0,17.41,40a15,15,0,0,0,4.73-2.37,1.08,1.08,0,0,0-.79-.31,7.3,7.3,0,0,1-5.2-3.63c-.2-.32-.47-.73-.31-1.06s.64-.11,1-.12a4.69,4.69,0,0,0,1.82-.26,8.23,8.23,0,0,1-3.38-2,7.08,7.08,0,0,1-2.14-4.45c-.06-.73.14-.74.71-.46a2.9,2.9,0,0,0,2,.39c-.53-.87-1.37-1.43-1.83-2.31A7.42,7.42,0,0,1,13.64,17c.35-.85.73-.52,1.16,0a19.66,19.66,0,0,0,8.13,5.62,20.25,20.25,0,0,0,5.27,1.19c.63,0,.81-.08.73-.78a7.21,7.21,0,0,1,7.3-8.06,6.57,6.57,0,0,1,4.6,1.77,1.33,1.33,0,0,0,1.44.33,26.75,26.75,0,0,0,3.47-1.35c-.13,1.12-.38,1.49-2.45,3.63C44.57,19.41,45.61,18.67,46.78,18.59Z"
                  transform="translate(0.01 0)"
                  style="fill: #fff"
                ></path>
              </svg>
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
